import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  Grid,
  Checkbox,
  ListItemText,
  Alert,
  Box,
  FormHelperText,
} from "@mui/material";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import AlertTitle from "@mui/material/AlertTitle";
import OutlinedInput from "@mui/material/OutlinedInput";
import LoadingButton from "@mui/lab/LoadingButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from "axios";
import { RolesContext } from "../context/User";
import { useNavigate } from "react-router-dom";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 200,
    },
  },
};

const FormulaForm = ({ idUser, refresh, refreshEffect }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrormessage] = useState(false);
  const [helpertext, sethelpertext] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [disableButton, setDisableButton] = useState(true);
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    name: "",
    lastname: "",
    cellphone: "",
    email: "",
    phonenum: "000",
    neo_companyname: "41",
    positiondes: "general",
    cust_id: stateroles.userId,
    custdes:
      stateroles.customers.find(
        (customer) => customer.CUSTNAME === stateroles.userId
      )?.CUSTDES || "",
    neo_paybyapp: "N",
    insert_to_specific_cust: "1",
    roles: ["portal"],
    term_use: "",
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    refresh(refreshEffect == true ? false : true);
    setOpen(false);
    setAlert(false);
    setError(false);
    setErrormessage(false);
    setFormValues({
      name: "",
      lastname: "",
      cellphone: "",
      email: "",
      phonenum: "000",
      neo_companyname: "41",
      positiondes: "general",
      cust_id: stateroles.userId,
      custdes:
        stateroles.customers.find(
          (customer) => customer.CUSTNAME === stateroles.userId
        )?.CUSTDES || "",
      neo_paybyapp: "N",
      insert_to_specific_cust: "1",
      roles: ["portal"],
      term_use: "",
    });
  };

  const handleSave = async () => {
    setErrormessage(false);
    const areAnyValuesEmpty = Object.values(formValues).some(
      (value) => value == ""
    );
    if (areAnyValuesEmpty) {
      if (formValues.custdes == "") {
        setErrormessage(true);
        setAlertText("התקבלה שגיאה");
      }
      sethelpertext("חסר פרטים");
      setError(true);
    } else {
      let adduser = "";
      if (formValues.insert_to_specific_cust == "0") {
        adduser = "insert_contact_to_all_cust";
      } else {
        adduser = "insert_contact_for_specific_cust";
      }

      setLoading(true);
      try {
        const response = await axios.post(`/adminPermissions/${adduser}`, {
          formValues,
        });
        if (response.status == 200) {
          setAlert(true);
          setLoading(false);
          setTimeout(() => {
            setAlert(false);
            handleClose();
          }, 3000);
          refresh(refreshEffect == true ? false : true);
        }
      } catch (error) {
        if (error.response.status == 409) {
          setLoading(false);
          setErrormessage(true);
          setAlertText("איש קשר כבר קיים במערכת");
          refresh(refreshEffect == true ? false : true);
        } else if (error.response.status == 403) {
          navigate("/");
        } else if (error.response.status == 402) {
          setLoading(false);
          setErrormessage(true);
          setAlertText("אינך מורשה להוסיף איש קשר");
        } else {
          setLoading(false);
          setErrormessage(true);
          setAlertText("התקבלה שגיאה");
          refresh(refreshEffect == true ? false : true);
        }
      }
    }
  };

  const handleChange = (event) => {
    if (event.target.name == "neo_paybyapp") {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.checked ? "Y" : "N",
      });
    } else if (event.target.name == "insert_to_specific_cust") {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.checked ? "0" : "1",
      });
    } else if (event.target.name == "term_use") {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.checked ? true : false,
      });
      setDisableButton(event.target.checked ? false : true);
    } else {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleRolesChange = (event) => {
    const {
      target: { value },
    } = event;

    const selectedRoles = typeof value === "string" ? value.split(",") : value;
    
    // Ensure "portal" is always included
    if (!selectedRoles.includes("portal")) {
      selectedRoles.push("portal");
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      roles: selectedRoles,
    }));
  };

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "none", md: "flex" },
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
          sx={{ marginBottom: "1rem" }}
          startIcon={<PersonAddAlt1Icon />}
        >
          הוספת משתמש
        </Button>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "flex", md: "none" },
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
          sx={{ marginBottom: "1rem" }}
          startIcon={<PersonAddAlt1Icon />}
        >
          הוספת משתמש
        </Button>
      </Box>

      {/* -------------------DIALOG--------------------  */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle style={{ textAlign: "right" }}>
          בקשה להוספת איש קשר למשתמש{" "}
        </DialogTitle>
        <DialogContent style={{ textAlign: "right" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                helperText={error && formValues.name == "" ? helpertext : ""}
                error={error && formValues.name == ""}
                required
                label="שם פרטי"
                fullWidth
                name="name"
                value={formValues.name}
                onChange={handleChange}
                sx={{ marginTop: "1rem" }}
                inputProps={{ style: { textAlign: "right" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                helperText={
                  error && formValues.lastname == "" ? helpertext : ""
                }
                error={error && formValues.lastname == ""}
                required
                label="שם משפחה"
                fullWidth
                name="lastname"
                value={formValues.lastname}
                onChange={handleChange}
                inputProps={{ style: { textAlign: "right" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                helperText={
                  error && formValues.cellphone == "" ? helpertext : ""
                }
                error={error && formValues.cellphone == ""}
                required
                label="טלפון"
                fullWidth
                name="cellphone"
                value={formValues.cellphone}
                onChange={handleChange}
                inputProps={{ style: { textAlign: "right" } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                helperText={error && formValues.email == "" ? helpertext : ""}
                error={error && formValues.email == ""}
                required
                label="מייל"
                fullWidth
                name="email"
                value={formValues.email}
                onChange={handleChange}
                inputProps={{ style: { textAlign: "right" } }}
              />
            </Grid>
          </Grid>

          <FormControl fullWidth sx={{ marginTop: "1rem" }}>
            <InputLabel id={"label2_" + idUser}>הרשאות</InputLabel>
            <Select
              error={error && formValues.roles.length == 0}
              labelId={"label2_" + idUser}
              label={"הרשאות"}
              multiple
              name="roles"
              value={formValues.roles}
              onChange={handleRolesChange}
              input={<OutlinedInput label="הרשאות" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              <MenuItem value="linkopeninvoice">
                <Checkbox
                  checked={formValues.roles.includes("linkopeninvoice")}
                />
                <ListItemText
                  primary={"חשבוניות לתשלום"}
                  secondary={"linkopeninvoice"}
                />
              </MenuItem>
              <MenuItem value="roles">
                <Checkbox checked={formValues.roles.includes("roles")} />
                <ListItemText primary={"הרשאות"} secondary={"roles"} />
              </MenuItem>
              <MenuItem value="portal">
                <Checkbox checked={formValues.roles.includes("portal")} disabled />
                <ListItemText
                  primary={"פורטל (ברירת מחדל)"}
                  secondary={"portal"}
                />
              </MenuItem>
              <MenuItem value="getinvoice">
                <Checkbox checked={formValues.roles.includes("getinvoice")} />
                <ListItemText
                  primary={"חשבוניות וקבלות"}
                  secondary={"getinvoice"}
                />
              </MenuItem>
              <MenuItem value="openorder">
                <Checkbox checked={formValues.roles.includes("openorder")} />
                <ListItemText primary={"הזמנות"} secondary={"openorder"} />
              </MenuItem>
              <MenuItem value="shipping">
                <Checkbox checked={formValues.roles.includes("shipping")} />
                <ListItemText primary={"תעודות משלוח"} secondary={"shipping"} />
              </MenuItem>
            </Select>
            <FormGroup
              style={{ flexDirection: "row-reverse", marginRight: "-1.4rem" }}
            >
              <FormControlLabel
                control={<Checkbox />}
                label="הוספת איש קשר לכל הלקוחות"
                style={{ flexDirection: "row-reverse" }}
                labelPlacement="start"
                onChange={handleChange}
                name="insert_to_specific_cust"
                value={formValues.insert_to_specific_cust}
              />
            </FormGroup>
            <FormGroup
              style={{ flexDirection: "row-reverse", marginRight: "-1.4rem" }}
            >
              <FormControlLabel
                control={<Checkbox />}
                label="תשלום חוב פתוח"
                style={{ flexDirection: "row-reverse" }}
                labelPlacement="start"
                onChange={handleChange}
                name="neo_paybyapp"
                value={formValues.neo_paybyapp}
              />
            </FormGroup>

            <FormControl required error={error}>
              <FormGroup
                style={{
                  flexDirection: "row-reverse",
                  marginRight: "-1.4rem",
                }}
              >
                <FormControlLabel
                  control={<Checkbox />}
                  label={
                    <span
                      style={{
                        fontSize: "12px",
                      }}
                      dir="rtl"
                    >
                      קראתי ואני מאשר את תנאי השימוש. המבקש מתחייב למלא ולעמוד
                      בכל דרישות תנאי השימוש וידוע לי שהחברה רשאית לבטל הרשאה
                      כאמור או לא לאשרה.
                    </span>
                  }
                  labelPlacement="start"
                  onChange={handleChange}
                  name="term_use"
                  value={formValues.term_use}
                />
                <FormHelperText style={{ marginRight: "10%" }}>
                  שדה חובה
                </FormHelperText>
              </FormGroup>
            </FormControl>

            {alert ? (
              <Alert
                sx={{
                  marginTop: "1rem",
                  textAlign: "left",
                  justifyContent: "flex-end",
                }}
                icon={false}
              >
                הוספת משתמש בוצע בהצלחה
              </Alert>
            ) : null}
          </FormControl>
        </DialogContent>
        {errorMessage ? (
          <Alert
            sx={{
              marginTop: "1rem",
              textAlign: "left",
              justifyContent: "flex-end",
            }}
            severity="warning"
            icon={false}
          >
            {alertText}
          </Alert>
        ) : null}
        <DialogActions style={{ justifyContent: "flex-start" }}>
          <Button onClick={handleClose} color="primary">
            ביטול
          </Button>
          <LoadingButton
            disabled={disableButton}
            color="primary"
            loading={loading}
            onClick={handleSave}
          >
            <span>שמור</span>
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FormulaForm;
